import src from "IMAGE";
export default { src, width: 109, height: 43, blurWidth: 0, blurHeight: 0};
